







































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateAgencyGroupRequest from '@/models/AgencyGroups/UpdateAgencyGroupRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';

@Component({
    name: 'AgencyGroupEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new UpdateAgencyGroupRequest

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new UpdateAgencyGroupRequest();
      const existingVal = JSON.parse(JSON.stringify(AgencySettingsModule.currentAgencyGroup));
      this.entity.name = existingVal.name;
      this.entity.updatedAt = existingVal.updatedAt;
      for (let index = 0; index < existingVal.agencyUsers.length; index++) {
        this.entity.agencyUserIds.push(existingVal.agencyUsers[index].id);
      }
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get users() {
    return AgencySettingsModule.agencyUsers.filter(function(agencyUser){
        if (agencyUser.status === AgencyUserStatus.Active ) {
          return true;
        }
        return false;
      })
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await AgencySettingsModule.editAgencyGroup(this.entity)
    this.dialog = false;
  }
}
